import React from 'react';
import { useTranslation } from 'react-i18next';
import { facturationClampPage, resolveFacturationPageSize } from '../utils/facturationTablePageSize';
import { useFacturationConfig } from '../useFacturationConfig';

/**
 * شريط ترقيم الصفحات لقوائم الفوترة — يقرأ حجم الصفحة من إعدادات الوحدة.
 */
export default function FacturationListPaginationBar({
  totalItems,
  rawPage,
  onPageChange,
  pageSize: pageSizeProp,
}) {
  const { t } = useTranslation();
  const facturationConfig = useFacturationConfig();
  const pageSize = pageSizeProp ?? resolveFacturationPageSize(facturationConfig);
  const p = (key, opts) => t(`modules.facturation.pages.facturationListPaginationBar.${key}`, opts);

  const total = typeof totalItems === 'number' && totalItems >= 0 ? totalItems : 0;
  if (total <= pageSize) return null;

  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const page = facturationClampPage(rawPage ?? 1, total, pageSize);
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 text-sm text-white/70 facturation-list-pagination">
      <span className="text-white/65">
        {p('showing_range', { from, to, total })}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onPageChange?.(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="px-3 py-1.5 bg-white/10 hover:bg-white/15 rounded-lg text-white disabled:opacity-45 disabled:cursor-not-allowed border border-white/15"
        >
          {p('previous')}
        </button>
        <span className="px-2 py-1.5 text-white/50 tabular-nums select-none flex items-center" aria-live="polite">
          {p('page_of', { page, total: totalPages })}
        </span>
        <button
          type="button"
          onClick={() => onPageChange?.(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className="px-3 py-1.5 bg-white/10 hover:bg-white/15 rounded-lg text-white disabled:opacity-45 disabled:cursor-not-allowed border border-white/15"
        >
          {p('next')}
        </button>
      </div>
    </div>
  );
}
